import { z } from 'zod';
import { counter } from './counts.js';
import { pageOf } from './paging.js';
import { emailSchema } from './signUp.js';
/**
 * The two states a message can reach that no worker will move again.
 *
 * `dead` is out of retries and is replayable. `unknown` is an ambiguous send:
 * the provider never gave a clear answer, so the mail may well have gone, and
 * replaying it blindly is how duplicate delivery returns. It is resolved by
 * somebody checking the provider's own record, never automatically.
 */
export const stuckStatusSchema = z.enum(['dead', 'unknown']);
export const stuckMessageSchema = z.object({
    queueEntryId: z.string(),
    email: emailSchema,
    /** Null for transactional mail, which belongs to no campaign. */
    campaignName: z.string().nullable(),
    /** Ours. This is what to search the provider for when reconciling. */
    messageId: z.string(),
    attempts: counter,
    lastError: z.string().nullable(),
    /** When it landed in this state. */
    since: z.iso.datetime(),
});
export const stuckPageSchema = pageOf(stuckMessageSchema);
/**
 * What somebody found when they looked the message up at the provider.
 *
 * Not a guess and not a default. `not-delivered` causes a re-send, and the only
 * thing making that safe is that the ambiguity has actually been resolved.
 */
export const reconciliationSchema = z.enum(['delivered', 'not-delivered']);
export const resolveUnknownRequestSchema = z.object({ as: reconciliationSchema });
/**
 * Both actions answer the same three ways, so they share a shape.
 *
 * `stale` is the row having moved since the screen drew it — a reaper took it,
 * or somebody else acted first. Not an error: the honest answer is that the
 * button did nothing and why.
 */
export const queueActionResponseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('done') }),
    z.object({ status: z.literal('stale') }),
]);
//# sourceMappingURL=queueOps.js.map